<template>
  <div id="app">
    <navigation />
    <footer data-footer-fixed="1">
      <div class="container">
        <div class="links">
          <a href="/color-canvas">color</a>
          <a href="/camera">camera</a>
          <a href="/tag">tag</a>
        </div>
        <div class="text-center">
          <div class="vlt-footer-copyright">
            <h5>viz.photos &copy; 2019</h5>
            <p>a data vizualisation project by r42 communication</p>
          </div>
          <div class="social-links">
            <ul>
              <li>
                <a target="_blank" href="//twitter.com/ralph_spandl" title="Twitter">
                  <i class="icofont-twitter" />
                </a>
              </li>
              <li>
                <a target="_blank" href="//www.linkedin.com/in/spandl/" title="LinkedIn">
                  <i class="icofont-linkedin" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
// @ is an alias to /src
import Navigation from "@/components/navigation.vue"

export default {
    name: "App",
    components: {
        Navigation
    }
}
</script>



<style lang="stylus" src="../src/components/css/base.styl"></style>

